module.exports = __webpack_public_path__ + "static/media/Rubik-Black.99e5b40f.ttf";